import React, { Component } from "react";

// import WorkGallery from "./workgallery/WorkGallery";
const baseUrl = process.env.PUBLIC_URL;
const PHOTODATA = [
  {
    id: 1,
    category: "Graphic Design",
    imageUrl: `${baseUrl}/assets/images/img-1.jpg`
  },
  {
    id: 2,
    category: "Graphic Design",
    imageUrl: `${baseUrl}/assets/images/img-2.jpg`
  },
  {
    id: 3,
    category: "Graphic Design",
    imageUrl: `${baseUrl}/assets/images/img-3.jpg`
  },
  {
    id: 4,
    category: "Graphic Design",
    imageUrl: `${baseUrl}/assets/images/img-4.jpg`
  },
  {
    id: 5,
    category: "Graphic Design",
    imageUrl: `${baseUrl}/assets/images/img-5.jpg`
  },
  {
    id: 6,
    category: "Web Design",
    imageUrl: `${baseUrl}/assets/images/img-6.jpg`
  }
];

export class FilterPanel extends Component {
  render() {
    return (
      <span>
        <a className={this.props.activeClass} onClick={this.props.onClick}>
          {this.props.category}
        </a>
      </span>
    );
  }
}

export class Photo extends Component {
  render() {
    return (
      <div className="photo-container" data-category={this.props.category}>
        <img src={this.props.imageUrl} alt="work" />
      </div>
    );
  }
}

class WorkComponent extends Component {
  state = {
    displayedCategories: PHOTODATA,
    active: false
  };
  toggleActive = () => {
    return this.setState({
      active: !this.state.active
    });
  };

  selectCategory = element => {
    console.log("element is: " + element);
    const categoryName = element.toLowerCase();
    const displayedCategories = PHOTODATA.filter(function(el) {
      var searchValue = el.category.toLowerCase();
      return searchValue.indexOf(categoryName) !== -1;
    });

    this.setState({
      displayedCategories: displayedCategories
    });
  };

  resetFilter = element => {
    this.setState({
      displayedCategories: PHOTODATA
    });
  };
  render() {
    const buttonClass = this.state.active ? "active" : "";
    const categoryToSelect = this.selectCategory;
    const getUniqueCategories = [];
    PHOTODATA.forEach(function(el) {
      if (getUniqueCategories.indexOf(el.category) === -1)
        getUniqueCategories.push(el.category);
    });
    return (
      <div>
        <section className="colorlib-work" data-section="work">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <span className="heading-meta">My Work</span>
                <h2 className="colorlib-heading animate-box">Recent Work</h2>
              </div>
            </div>
            <div
              className="row row-bottom-padded-sm animate-box"
              data-animate-effect="fadeInLeft"
            >
              <div className="col-md-12">
                <p className="work-menu">
                  <a className="resetBtn" onClick={this.resetFilter}>
                    All
                  </a>
                  {getUniqueCategories.map(function(el, i) {
                    var boundClick = categoryToSelect.bind(null, el);

                    // console.log(boundClick);
                    return (
                      <FilterPanel
                        activeClass={buttonClass}
                        onClick={boundClick}
                        category={el}
                        key={i}
                      />
                    );
                  })}
                </p>
              </div>
            </div>
            <div className="row photo-wraper">
              {this.state.displayedCategories.map(function(el) {
                return (
                  <Photo
                    key={el.id}
                    imageUrl={el.imageUrl}
                    category={el.category}
                  />
                );
              })}
            </div>

            {/* <div className="row">
              <div className="col-md-12 animate-box">
                <p>
                  <a href="#" className="btn btn-primary btn-lg btn-load-more">
                    Load more <i className="icon-reload"></i>
                  </a>
                </p>
              </div>
            </div> */}
          </div>
        </section>
      </div>
    );
  }
}

export default WorkComponent;
